import styled from 'styled-components';
import Colors from 'assets/Colors';

const HeaderWrapper = styled.div`
  display: flex;
  padding: 12px;
  border-bottom: 1px solid ${Colors.line_separator};
  align-items: center;
  justify-content: space-between;
`;

const HeaderContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const MenuIconWrapper = styled.div`
  display: grid;
  place-items: center;
  cursor: pointer;
`;

const SectionTitle = styled.div`
  margin-left: 15px;
  margin-left: 15px;
  font-size: 18px;
  font-weight: 600;
  align-content: center;
`;

const BodyWrapper = styled.div`
  padding: 15px;
`;

export default {
  MenuIconWrapper,
  HeaderWrapper,
  SectionTitle,
  BodyWrapper,
  HeaderContentWrapper,
};
